import Point from 'esri/geometry/Point';
import SpatialReference from 'esri/SpatialReference';

import { Promise as bbPromise } from 'promise';

import { criteriaStore } from 'stores/CriteriaStore';
import { reportStore } from 'stores/ReportStore';

import { esriQuery } from 'js/utils/esriQueries';

import { handleSnowNoFeatures, handleSnowForNewHampshire, handleSnow, handleSnowFor722 } from 'js/loads/snow';

const querySnow = (location, load) => {
  return new bbPromise((resolve, reject) => {
    try {
      // retrieve query parameters (elevation is in feet/imperial)
      const { standardsVersion, elevation, measurement, riskLevel } = criteriaStore.getState();
      // create geometry from location event
      const geometry = new Point(location.long, location.lat, new SpatialReference({ wkid: 4326 }));

      // query states
      esriQuery(load.layers.query.stateZoneURL, {
        outFields: ['*'],
        geometry,
      }).then(
        (stateQueryResult) => {
          // handle no features
          if (!stateQueryResult.features.length) {
            load = handleSnowNoFeatures(load);
            reportStore.emitChange();
            resolve({ load: load.label });
          }

          const [feature] = stateQueryResult.features;
          const { STATE_NAME } = feature.attributes;

          // handle the special case for new hampshire and latest standards
          let promise;
          if (STATE_NAME === 'New Hampshire' && standardsVersion === '7-16') {
            promise = handleSnowForNewHampshire(load, standardsVersion, elevation, measurement, geometry);
          } else {
            if (standardsVersion === '7-22') {
              promise = handleSnowFor722(load, riskLevel, measurement, geometry, STATE_NAME);
            } else {
              promise = handleSnow(load, standardsVersion, elevation, measurement, geometry, STATE_NAME);
            }
          }
          promise
            .then((derivedLoad) => {
              load = derivedLoad;
              load.showInReport = true;
              reportStore.emitChange();
              resolve({ load: load.label });
            })
            .catch((error) => {
              console.log('Error: ', error.message);
              reject({ load: load.label, error });
            });
        },
        (error) => {
          console.log('Error: ', error);
          reject({ load: load.label, error });
        }
      );
    } catch (error) {
      reject({ load: load.label, error });
    }
  });
};

export default querySnow;
